import "./style.css"
import "./polyfills/setIntersection"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { BaseApp } from "./BaseApp"

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<BaseApp />
	</StrictMode>,
)
